<template>
	<div class="col-lg-3 col-sm-12 spotlight">
		<div class="card mb-3">
			<b-form @submit.prevent="saveContainer" @reset.prevent="$router.push({ name: 'yb-container-view', params: { id: recordId }})">
				<div class="card-header pb-2 pt-2">
					<span>Container Info</span>
				</div>
				<div class="list-group list-group-flush">
					<div class="list-group-item pt-1 pb-1">
					<span>
						<b-button type="submit" variant="primary">Save</b-button>
					</span>
					<span class="float-right">
						<b-button type="reset" variant="secondary">Cancel</b-button>
					</span>
					</div>
				</div>
				<div class="card-body">
					<div class="row job-row">
						<div class="col-12">
							<div><strong>Container Name</strong></div>
							<ValidationProvider v-slot="v" ref="Container Name">
								<b-form-input class="form-control job-field"
											  v-model="record.fieldData['Container Name']"/>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Pallet</strong></div>
							<ValidationProvider v-slot="v" ref="Pallet">
								<b-form-input class="form-control job-field"
											  v-model="record.fieldData.Pallet"/>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Type</strong></div>
							<ValidationProvider v-slot="v" ref="Container Type">
								<v-select
											   v-model="record.fieldData['Container Type']"
											   :options="containerTypes"></v-select>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Pkg Wt</strong></div>
							<ValidationProvider v-slot="v" ref="Package Weight">
								<b-form-input class="form-control job-field"
											  v-model="record.fieldData['Package Weight']"/>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Net Wt</strong></div>
							<ValidationProvider v-slot="v" ref="Net Weight">
								<b-form-input class="form-control job-field"
											  v-model="record.fieldData['Net Weight']"/>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Gross Wt</strong></div>
							<div class="job-field">{{ record.fieldData['Gross Weight'] }}</div>
						</div>
						<div class="col-12">
							<div><strong>Gross UoM</strong></div>
							<ValidationProvider v-slot="v" ref="Gross UoM">
								<v-select v-model="record.fieldData['Gross UoM']"
											   :options="UoMs"></v-select>
							</ValidationProvider>
						</div>
					</div>
				</div>
			</b-form>
		</div>
	</div>
</template>

<script>
import BaseEdit from '../BaseEdit'
import feedbackMixin from '../../mixins/feedback'
import router from '../../router'

export default {
	name: "YBContainerEdit",
	extends: BaseEdit,
	mixins: [feedbackMixin],
	data() {
		return {
			validationRefs: ['Container Name', 'Pallet', 'Container Type', 'Package Weight', 'Net Weight', 'Gross UoM'],
			containerTypes: [
				'',
				'DF',
				'DM',
				'BX',
				'PA',
				'55 G Steel',
				'55 G Poly',
				'Poly Tote',
				'Tank',
				'Tote',
				'Plastic',
				'Pallet',
				'Gaylord'
			],
			UoMs: [
				'',
				'Lb',
				'kg',
				'g'
			]
		}
	},
	methods: {
		saveContainer() {
			let dirtyFields = {}
			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if (validationProvider.flags.dirty) {
					dirtyFields[value] = this.record.fieldData[value]
				}
			})
			this.save({fieldData: dirtyFields})
		},
	},
	beforeRouteEnter: function (to, from, next) {
		console.log('From route ' + from.name);
		if (from.name !== 'yb-container-view' && from.name !== 'job-view') {
			router.replace({name: 'yb-container-view', params: to.params})
		} else {
			next()
		}
	},
	beforeRouteUpdate: function (to, from, next) {
		console.log('From route ' + from.name);
		if (from.name !== 'yb-container-view' && from.name !== 'job-view') {
			this.$router.replace({name: 'yb-container-view', params: to.params})
		} else {
			next()
		}
	}
}
</script>